import { ReactNode } from "react";
import {
  ADMIN_PERMISSIONS,
  type AdminPermissionKey,
} from "@/project/karuna/constants/adminPermissions";
import { RequireAdminPermission } from "@/project/karuna/components/admin/RequireAdminPermission";

export function adminRoute(permission: AdminPermissionKey, element: ReactNode) {
  return (
    <RequireAdminPermission permission={permission}>
      {element}
    </RequireAdminPermission>
  );
}

export { ADMIN_PERMISSIONS };
